import MentionsTextarea from './MentionsTextarea';

export default MentionsTextarea;